import { Checkbox, Space } from "antd-v5";
import { uniq } from "lodash";
import React from "react";

import ACResponsiveTags from "ac-components/ac-responsive-tags/ACResponsiveTags";

import "./ACMultiSelectCheckbox.less";

interface Option {
  label: string;
  value: string;
  disabled?: boolean;
  secondaryText?: string[];
}

interface ACMultiSelectCheckboxProps {
  options: Option[];
  defaultValue?: string[];
  value?: string[];
  onChange?: (selectedValues: string[]) => void;
  disabled?: boolean;
  className?: string;
}

const ACMultiSelectCheckbox: React.FC<ACMultiSelectCheckboxProps> = ({
  options = [],
  defaultValue = [],
  value,
  onChange,
  disabled = false,
  className = "",
}) => {
  const finalValues = value || defaultValue;

  const handleCheckboxChange = (optionValue: string, checked: boolean) => {
    if (disabled) return;

    let newSelectedValues: string[];

    if (checked) {
      newSelectedValues = uniq([...finalValues, optionValue]);
    } else {
      newSelectedValues = finalValues.filter((v) => v !== optionValue);
    }

    onChange?.(
      options
        .filter((option) => newSelectedValues.includes(option.value))
        .map((option) => option.value),
    );
  };

  const isChecked = (optionValue: string) => {
    return finalValues.includes(optionValue);
  };

  return (
    <div className={`ac-multi-select-checkbox ${className}`}>
      <Space direction="vertical" size="small" style={{ width: "100%" }}>
        {options.map((option) => {
          const checked = isChecked(option.value);
          const isDisabled = option.disabled;

          return (
            <div key={option.value} className="option-card">
              <div className="option-content">
                <div className="option-label-container">
                  <div
                    className={`option-label ${isDisabled ? "disabled-option" : ""}`}
                  >
                    {option.label}
                  </div>
                  {option.secondaryText && (
                    <div className="option-secondary-text">
                      <ACResponsiveTags
                        tags={option.secondaryText || []}
                        tagProps={{ mode: "plain" }}
                      />
                    </div>
                  )}
                </div>
              </div>
              <Checkbox
                checked={checked}
                disabled={disabled || isDisabled}
                onChange={(e) =>
                  handleCheckboxChange(option.value, e.target.checked)
                }
                className={`option-checkbox ${isDisabled ? "disabled-option" : ""}`}
              />
            </div>
          );
        })}
      </Space>
    </div>
  );
};

export default ACMultiSelectCheckbox;
